import {IValidationRule} from '@core/api/data-access';
import {IBaseStore} from '@global-data';

export namespace ValidationRulesStoreState {
	export type IValidationRulesState = IBaseStore & {
		validations: IValidationRule[];
	};

	export const validationRulesInitialState: IValidationRulesState = Object.freeze({
		validations: null,
		loaded: false,
		loading: false,
		lastUpdated: 0,
	});
}
